import { Post, Work } from "generated-graphql";
import { A3ResourceProps } from "@/componentsWP/A3Player/A3Player";
import WorkItem from "../WorkItem/WorkItem";
import ResourceListItem from "../ResourceList/ResourceListItem";
import ResourceItem from "../ResourceItems/ResourceItem";

const TileList: React.FC<A3ResourceProps> = ({ items, description }) => {
  const getColumnClass = (idx: number) => {
    switch (idx) {
      case 0:
        return "col-lg-12";
      case 1:
      case 2:
        return "col-lg-6";
      default:
        return "col-lg-4";
    }
  };
  if (!items) {
    return null;
  }

  return (

    <div className="container">
      {description && <div dangerouslySetInnerHTML={{ __html: description }} />}
      <div className="row gx-5">
        {items.map((item, idx) => {

          return <div style={{ marginTop: 45, marginBottom: 45 }} key={"resourcelistItem" + idx} className="col-md-4">

            {item && <ResourceItem item={item} />}
            {/* <WorkItem item={item as Work} isFirst={idx === 0 || items.length === 2} />
             */}
            {/* {JSON.stringify(item)} */}
          </div>
        })}

      </div>
    </div >
  )

}

export default TileList;